export const settings = {
  tmdbApiKey: '305f39fec6c56bb09ef632dc407504e3',
  youtubeApiKey: 'AIzaSyCYB18fiG8-y0ib8wL9X1Pja6Kx0XeVKkk',
  tmdbBaseUrl: 'https://api.themoviedb.org/3',
};
